import { Injectable } from '@angular/core'
import { environment } from 'src/environments/environment'
import { ResultInfo, ResultInfoSingle } from '../common/api-common.interface'
import { HttpRequestService } from '../common/http-request.service'
import { Observable } from 'rxjs'
import {
  ProScheApplicationsEstimateResult,
  ProScheContractCompanyListResult,
  StockMigrationMessageInfo
} from './prosche-application.interface'

@Injectable({
  providedIn: 'root'
})
export class ProScheApplicationService {
  baseURL = environment.backendMacroBaseUrl

  constructor(private httpRequestService: HttpRequestService) {}

  /**
   *
   * @param customerCd 顧客CD
   * @returns
   * ProScheのメッセージ内容を取得
   */
  getProScheMessage(
    customerCd: string
  ): Observable<ResultInfoSingle<StockMigrationMessageInfo>> {
    const url = `${environment.myideaMacroBaseUrl}api/prosche/customers/${customerCd}/message`
    return this.httpRequestService.getResultSingle(url)
  }

  /**
   *
   * @param customerCd 
   * @returns
   * ProScheの継続申し込み
   */
  approval(
    customerCd: string
  ): Observable<ResultInfo<StockMigrationMessageInfo>> {
    const url = `${environment.myideaMacroBaseUrl}api/prosche/customers/${customerCd}/approval`
    return this.httpRequestService.post(url, null)
  }

    /**
   *
   * @param stockMigrationUserAndStatusIds 
   * @returns
   * ProScheの継続申し込み 戻し
   */
  testCancel(
    stockMigrationUserAndStatusIds: string[]
  ): Observable<ResultInfo<StockMigrationMessageInfo>> {
    const url = `${environment.myideaMacroBaseUrl}api/prosche/testCancel`
    return this.httpRequestService.post(url, stockMigrationUserAndStatusIds)
  }

  /**
   * 御見積書確認URL取得
   * @param id
   * @returns
   */
  getProScheApplicationsEstimate(id: string): Observable<ResultInfo<ProScheApplicationsEstimateResult>> {
    const url = `${this.baseURL}api/ProScheApplications/Estimate/${id}`
    return this.httpRequestService.get(url)
  }

  /**
   *
   * @returns
   * ProSche契約会社一覧結果
   */
  getProScheApplicationsContractCompanyList(): Observable<ResultInfo<ProScheContractCompanyListResult>> {
    const url = `${this.baseURL}api/ProScheApplications/ContractCompanyList`
    return this.httpRequestService.get(url)
  }

  /**
   *
   * @param companyOrganizationCds
   * @returns
   */
  postProScheApplicationSendMail(companyOrganizationCds: string[]): Observable<ResultInfo<boolean>> {
    const url = `${this.baseURL}api/ProScheApplications/SendMail`
    return this.httpRequestService.post(url, companyOrganizationCds)
  }
  
}
